import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconClock } from '#src/atoms/icons/system/iconClock.ts';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { Chip } from '#src/atoms/ui/Chip/index.tsx';
import { TimeLeft } from '#src/contexts/ticker/TimeLeft/index.tsx';

type Props = {
  deadline: Date;
};

export const ReferrerCodeCountdownChip = ({ deadline }: Props) => {
  return (
    <Chip color="yellow">
      <Horizontal gap={0.5}>
        <FontAwesomeIcon icon={iconClock} color="var(--c-yellow-400)" />
        <TimeLeft time={deadline} />
      </Horizontal>
    </Chip>
  );
};
